import Model  from '@/util/models';
import Kelurahan from './Kelurahan';

export default class Tps extends Model { 
    backend = '/frc/tps/'; 
    
    kelurahans(params){
      return this.api.get(this.backend + 'kelurahans', params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
    
    kecamatans(params){
      return this.api.get(this.backend + 'kecamatans', params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
    
    kotas(params){
      return this.api.get(this.backend + 'kotas', params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
}

